import { VATIcon } from '@/assets/theme/default/walletIcons/vat/VATIcon';
import { Currency, CurrencyProps } from '@/components/general/Currency/Currency';
import { WALLET_PHRASES } from '@/consts/phrases/walletPhrases';
import { usePhrase } from '@/hooks/general/usePhrase/usePhrase';
import { Stack, Typography } from '@mui/material';

interface VATAmountProps extends CurrencyProps {
    listingView?: boolean;
}

export const VATAmount = ({ code, symbol, amount, position, listingView }: VATAmountProps) => {
    const { t } = usePhrase();

    return (
        <Stack
            direction="row"
            spacing={0.5}
            sx={{
                alignItems: 'center',
                mb: 1,
            }}
        >
            <VATIcon style={{ flexShrink: 0 }} />
            <Typography
                variant="body1"
                className="VATAmountText"
                sx={(theme) => ({
                    fontSize: listingView ? '0.875rem' : theme.typography.subtitle3,
                })}
            >
                <span>{t(WALLET_PHRASES.VAT)}</span>{' '}
                <Currency code={code} symbol={symbol} amount={amount} position={position} />
            </Typography>
        </Stack>
    );
};
